export function validators(madSDK) {
    return {
        name: (template, value) => {
            if (!value?.trim()) {
                return "Name field is required.";
            }
            return undefined;
        },
        publisherSettings: (template, value) => {
            for (const publisherSetting of value || []) {
                const validation = madSDK.publishers.optimizationTemplates.publisherSettings.validate(publisherSetting);
                if (validation?.size > 0) {
                    return validation.values().next().value;
                }
            }
            return undefined;
        }
    };
}
//# sourceMappingURL=validators.js.map